import axios from 'axios';

const checkAvailability = (username, email) => {
  const config = {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
  };

  const body = {
    username,
    email,
  };

  return axios.post(`${process.env.NEXT_PUBLIC_GRAPPLE_BACKEND_URL}check-availability`, body, config);
};

export default checkAvailability;
